import { FC } from 'react';

import { DirectoryRecordData } from 'api/types/data/directory/directory';
import { GridFields, FormErrorFocus } from 'components';
import { Box } from 'libs/ui';
import { RecordField } from 'modules/directory/common/components';
import { FieldConfig } from 'modules/directory/common/types';

export interface FormContentProps {
  fieldsConfig: FieldConfig[];
  record?: DirectoryRecordData;
}

export const FormContent: FC<FormContentProps> = ({ fieldsConfig, record }) => (
  <>
    <FormErrorFocus />
    <GridFields>
      {fieldsConfig.map((fieldConfig) => (
        <Box key={fieldConfig.name} flex={1}>
          <RecordField
            fieldConfig={fieldConfig}
            readOnly={
              !(
                record?.fields.find((f) => f.name === fieldConfig.name)
                  ?.isEditable ?? true
              )
            }
          />
        </Box>
      ))}
    </GridFields>
  </>
);
